module.exports = __webpack_public_path__ + "img/timer.add6a081.svg";